import React from 'react';

interface MusicIconProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const MusicIcon: React.FC<MusicIconProps> = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-12 h-12',
    md: 'w-16 h-16', 
    lg: 'w-24 h-24',
    xl: 'w-48 h-48'
  };

  return (
    <div className={`${sizeClasses[size]} ${className} relative overflow-hidden rounded-xl bg-gradient-to-br from-orange-500 via-purple-600 to-blue-600 flex items-center justify-center shadow-lg`}>
      {/* Vinyl Record Design */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-800 via-gray-900 to-black opacity-20"></div>
      
      {/* Outer Ring */}
      <div className="absolute inset-2 rounded-full border-2 border-white/20"></div>
      
      {/* Inner Ring */}
      <div className="absolute inset-4 rounded-full border border-white/15"></div>
      
      {/* Center Hole */}
      <div className="absolute inset-1/3 rounded-full bg-black/30 border border-white/10"></div>
      
      {/* Music Note Icon */}
      <svg 
        className="w-1/3 h-1/3 text-white z-10 drop-shadow-lg" 
        fill="currentColor" 
        viewBox="0 0 24 24"
      >
        <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/>
      </svg>
      
      {/* Shine Effect */}
      <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-transparent transform rotate-45"></div>
    </div>
  );
};

export default MusicIcon; 